<template>
    <div class="tw-flex tw-justify-center">
        <div class="tw-px-10 tw-py-4 tw-font-bold tw-bg-white tw-flex tw-flex-col tw-items-center">
            <i class="bx bx-loader-alt bx-spin tw-text-3xl"></i>
            <div>{{$word.please_wait}}</div>
        </div>
    </div>
</template>
<script>
    export default {}
</script>
